import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { MissedCallService, MissedCallData } from '../../../shared/services/missed-call.service';

@Component({
  selector: 'app-missed-call-popup',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './missed-call-popup.component.html',
  styleUrls: ['./missed-call-popup.component.scss'],
})
export class MissedCallPopupComponent implements OnInit, OnDestroy {
  missedCallData: MissedCallData | null = null;
  private sub!: Subscription;

  constructor(
    private missedCallService: MissedCallService,
    private router: Router,
  ) {}

  ngOnInit(): void {
    this.sub = this.missedCallService.missedCall$.subscribe((data) => {
      this.missedCallData = data;
    });
  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }

  dismiss(): void {
    this.missedCallService.dismissMissedCall();
  }

  callBack(): void {
    this.missedCallService.dismissMissedCall();
    this.router.navigate(['/patients/tele-consult']);
  }
}
